// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3BRgY","footer":"ReportModalFilter_footer__2owcZ"};